import React from 'react'
import {Modal} from 'common/modals'
import {Button} from 'common/buttons'
import Form, {Input, Textarea} from 'form'
import {AdventurePrivacy} from 'common/Dropdown'

import {useState, useMutation} from 'hooks'
import {mutationUpdateAdventure} from 'graph'

/** Edit an adventure's settings (title / description / privacy). Author only. */
export function AdventureSettingsModal(props: any)
{
	const {adventure, close} = props

	const [privacy, setPrivacy] = useState(adventure.privacy ?? 'PUBLIC')
	const [doUpdate, {loading}] = useMutation(mutationUpdateAdventure, {
		onCompleted() {
			close()
		},
		onError(error: any) { console.log(error) },
	})

	const onSubmit = (input: any) => doUpdate({
		variables: {
			input: {
				id: adventure.id,
				...input,
				privacy,
			},
		},
	})

	return (
		<Modal {...props}>
			<Form
				onSubmit={onSubmit}
				defaultValues={{title: adventure.title, description: adventure.description ?? ''}}
			>
				<div className="modal-body">
					<div>
						<h2>
							<small className="text-muted">Adventure settings</small><br/>
							{adventure.title}
						</h2>
					</div>
					<Input
						name="title"
						label="Title"
						placeholder="Give a meaningful title to your adventure"
						rules={{required: 'Please enter a title'}}
						outerClassName="mb-2"
					/>
					<Textarea
						name="description"
						label="Description"
						placeholder="Write a small description, what this adventure is about"
						outerClassName="mb-2"
					/>
					<AdventurePrivacy value={privacy} onChange={setPrivacy} />
				</div>
				<div className="modal-footer">
					<Button variant="outline-secondary" type="reset" onClick={close}>Cancel</Button>
					<Button variant="outline-success" disabled={loading} type="submit">Save</Button>
				</div>
			</Form>
		</Modal>
	)
}
